import React from 'react';
import RightToolsPanel from '../RightToolsPanel';
import BannerTitle from '../BannerTitle';
import { useLocale, useTranslations } from 'next-intl';
import QA from '../QA';
import Image from 'next/image';
import Eb3AdvantageItem from '../Eb3AdvantageItem';
import OtherCountries from '../OtheCountries';
import Link from 'next/link';
import Head from '@/components/commons/Head';

const LandingContent = () => {
  const t = useTranslations();
  const currentLocale = useLocale();

  return (
    <div className="box-border w-full bg-[#F1F5FF] pb-[4.992vw] pt-[1.04vw]">
      <Head
        title={'EB-3美国雇主担保移民：一步到位拿绿卡，低门槛高成功率'}
        description={
          'EB-3美国雇主担保移民，无学历语言要求，全家一步到位拿绿卡，适合18-55岁申请人。了解EB-3C非技术工人项目、排期、福利等详细信息'
        }
        keywords="美国EB-3移民，美国EB-3，EB-3，美国绿卡，如何移民美国,雇主担保移民，美国雇主担保移民，EB-3雇主担保，美国EB3，EB3，EB-3申请条件，美国移民排期 ，EB-3C非技术工人，EB-3移民要求，无语言要求的美国移民，低成本移民美国 ，留学生移民美国，陪读家长移民，EB-3费用，移民学历要求"
      />
      <div className="box-border flex w-full flex-row items-start justify-start px-[9.724vw] max-md:px-[30px]">
        <div className="flex-1">
          <BannerTitle title={t('Landing.eb3Title')} />
          {/* 内容 */}
          <div className="mb-[2.756vw] mt-[1.04vw] box-border w-full bg-white px-[1.56vw] pb-[2.6vw] pt-[2.08vw]">
            {/* 关于EB-3雇主担保移民 */}
            <div className="mb-[1.976vw] w-full">
              <div className="mb-[1.716vw] text-left text-[1.56vw] font-semibold leading-none text-[#111111]">
                【{t('Landing.aboutEB3')}】
              </div>
              <div className="mb-[1.22vw] text-[1.248vw] leading-normal text-black">{t('Landing.aboutEB3Text')}</div>
              <div className="text-[0.832vw] leading-[1.56vw] text-[#333333]">
                <div className="mb-[1.04vw]">{t('Landing.aboutEB3Content1')}</div>
                <div className="mb-[1.04vw]">{t('Landing.aboutEB3Content2')}</div>
                <div>{t('Landing.aboutEB3Content3')}</div>
              </div>
            </div>
            {/* EB-3适用人群 */}
            <div className="mb-[1.976vw] w-full">
              <div className="mb-[1.716vw] text-left text-[1.56vw] font-semibold leading-none text-[#111111]">
                【{t('Landing.eb3Applicant')}】
              </div>
              <div className="mb-[1.22vw] text-[1.248vw] leading-normal text-black">
                {t('Landing.eb3ApplicantText')}
              </div>
              <div className="text-[0.832vw] leading-[1.56vw] text-[#333333]">
                <div>{t('Landing.eb3ApplicantContent')}</div>
              </div>
              <div className="mb-[1.196vw] mt-[2.6vw] w-full text-[1.04vw] font-medium text-[#111111]">
                {t('Landing.eb3ApplicantContent2')}
              </div>
              <table className="mb-[1.248vw] w-full table-auto border-collapse overflow-hidden rounded-[0.52vw] border-2 border-white bg-[#F6F6FF] text-[0.832vw] leading-relaxed text-[#333333]">
                <colgroup>
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '24%' }} />
                  <col style={{ width: '39%' }} />
                  <col style={{ width: '27%' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th className="border-2 border-white bg-[#D2D4FF] px-4 py-4 text-[0.936vw] font-semibold text-[#111111]">
                      {t('Landing.category')}
                    </th>
                    <th className="border-2 border-white bg-[#D2D4FF] px-4 py-4 text-[0.936vw] font-semibold text-[#111111]">
                      {t('Landing.name')}
                    </th>
                    <th className="border-2 border-white bg-[#D2D4FF] px-4 py-4 text-[0.936vw] font-semibold text-[#111111]">
                      {t('Landing.requirement')}
                    </th>
                    <th className="border-2 border-white bg-[#D2D4FF] px-4 py-4 text-[0.936vw] font-semibold text-[#111111]">
                      {t('Landing.typicalPosition')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border-2 border-white px-4 py-4">EB-3A</td>
                    <td className="border-2 border-white px-4 py-4">Skilled Workers（技术工人）</td>
                    <td className="border-2 border-white px-4 py-4">
                      <div>{t('Landing.tableText1')}</div>
                      <div>{t('Landing.tableText2')}</div>
                    </td>
                    <td className="border-2 border-white px-4 py-4">{t('Landing.tableText3')}</td>
                  </tr>
                  <tr>
                    <td className="border-2 border-white px-4 py-4">EB-3B</td>
                    <td className="border-2 border-white px-4 py-4">Professionals（专业人士）</td>
                    <td className="border-2 border-white px-4 py-4">
                      <div>{t('Landing.tableText4')}</div>
                      <div>{t('Landing.tableText5')}</div>
                    </td>
                    <td className="border-2 border-white px-4 py-4">{t('Landing.tableText6')}</td>
                  </tr>
                  <tr>
                    <td className="border-2 border-white px-4 py-4">EB-3C</td>
                    <td className="border-2 border-white px-4 py-4">Other Workers（非技术劳工）</td>
                    <td className="border-2 border-white px-4 py-4">
                      <div>{t('Landing.tableText7')}</div>
                      <div>{t('Landing.tableText8')}</div>
                    </td>
                    <td className="border-2 border-white px-4 py-4">{t('Landing.tableText9')}</td>
                  </tr>
                </tbody>
              </table>
              <div className="mb-[2.86vw] w-full text-left text-[0.832vw] leading-[1.352vw] text-[#333333]">
                {t('Landing.eb3ApplicantContent3')}
              </div>
            </div>
            {/* 【EB-3C非技术劳工】项目要求 */}
            <div className="mb-[3.12vw] w-full">
              <div className="mb-[1.664vw] text-left text-[1.56vw] font-semibold leading-none text-[#111111]">
                {t('Landing.eb3CRequirement')}
              </div>
              <div className="text-left text-[1.04vw] leading-none text-black">{t('Landing.eb3CRequirementText')}</div>
              <Image
                src={`/images/landing/${currentLocale === 'en' ? 'request_en' : 'request'}.png`}
                width={901}
                height={291}
                className={'mb-[2.912vw] mt-[3.64vw] h-auto w-full'}
                alt="request"
              />
              <div className="text-left text-[0.832vw] leading-[1.3vw] text-[#333333]">
                {t('Landing.eb3CRequirementContent')}
              </div>
            </div>
            {/* 【EB-3项目优势】 */}
            <div className="mb-[3.64vw] w-full">
              <div className="mb-[1.716vw] text-left text-[1.56vw] font-semibold leading-none text-[#111111]">
                【{t('Landing.eb3Advantage')}】
              </div>
              <div className="mb-[2.912vw] text-left text-[0.832vw] leading-[1.3vw] text-black">
                {t('Landing.eb3AdvantageText')}
              </div>
              <div className="mb-[2.964vw] grid w-full grid-cols-2">
                <div className="flex flex-col items-center justify-start">
                  {new Array(3).fill(0).map((item, index) => {
                    return (
                      <Eb3AdvantageItem
                        className="mb-[1.56vw] last:mb-0"
                        key={index}
                        index={index}
                        itemPosition="left"
                        title={t(`Landing.eb3Advantage${index + 1}Title` as any)}
                        content={t(`Landing.eb3Advantage${index + 1}Content` as any)}
                      />
                    );
                  })}
                </div>
                <div className="mt-[3.484vw] flex flex-col items-center justify-start">
                  {new Array(3).fill(0).map((item, index) => {
                    const newIndex = index + 3;
                    return (
                      <Eb3AdvantageItem
                        className="mb-[1.56vw] last:mb-0"
                        key={newIndex}
                        index={newIndex}
                        itemPosition="right"
                        title={t(`Landing.eb3Advantage${newIndex + 1}Title` as any)}
                        content={t(`Landing.eb3Advantage${newIndex + 1}Content` as any)}
                      />
                    );
                  })}
                </div>
              </div>
              <div className="text-left text-[0.832vw] leading-[1.3vw] text-[#333333]">{t('Landing.eb3Risk')}</div>
            </div>
            {/* 了解更多 */}
            <div className="w-full">
              <div className="mb-[2.548vw] text-left text-[1.56vw] font-semibold leading-none text-[#111111]">
                【{t('Landing.eb3More')}】
              </div>
              <div className="mb-[1.768vw]">
                <Link
                  href="https://posts.starringglobal.com/%e7%be%8e%e5%9b%bd%e6%9d%b0%e5%87%ba%e4%ba%ba%e6%89%8d%e7%a7%bb%e6%b0%91%e4%b8%8e%e5%9b%bd%e5%ae%b6%e5%88%a9%e7%9b%8a%e8%b1%81%e5%85%8d%e7%a7%bb%e6%b0%91%ef%bc%88eb1aniw%ef%bc%89/"
                  target="_blank"
                  className="mb-[1.768vw] cursor-pointer text-[1.04vw] text-[#0047BD]"
                >
                  -{t('Landing.eb1Title1')}
                </Link>
              </div>
              <div>
                <Link
                  href="https://posts.starringglobal.com/%e7%be%8e%e5%9b%bdeb5%e6%8a%95%e8%b5%84%e7%a7%bb%e6%b0%91/"
                  target="_blank"
                  className="cursor-pointer text-[1.04vw] text-[#0047BD]"
                >
                  -{t('Landing.eb1Title2')}
                </Link>
              </div>
            </div>
          </div>
          <QA className="mb-[4.16vw]" />
          <OtherCountries />
        </div>
        <RightToolsPanel className="ml-[1.82vw]" />
      </div>
    </div>
  );
};

export default LandingContent;
